/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fit_Antsy_Swan_SplashInputs */

const fr_fit_antsy_swan_splash = /** @type {(inputs: Fit_Antsy_Swan_SplashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expiré`)
};

/**

* @param {Fit_Antsy_Swan_SplashInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fit_antsy_swan_splash = /** @type {((inputs?: Fit_Antsy_Swan_SplashInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fit_Antsy_Swan_SplashInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fit_antsy_swan_splash(inputs)
});